import { FlujoTesoreriaReadingFiltersDtoProps } from "api/DTOs/FlujoTesoreriaReadingFiltersDto"
import { TIPO_CONCILIACION } from "api/Types/TipoConciliacion"
import { ConciliacionesImporteTemplate } from "features/Documentos/templates"
import { TFunction } from "i18next"
import { Dispatch, SetStateAction } from "react"
import { frontendDateFormat } from "utils/formatDate"
import OnRenderAccountInfo from "./components/PagosCobrosTable/OnRenderAccountInfo"
import { ConciliableLabel, DocumentoAsociadoAsiento } from "./constants"

export const PAGOS_COBROS_COLUMNS = (
  t: TFunction,
  setShowModalConciliacion: Dispatch<
    SetStateAction<{
      show: boolean
      data: FlujoTesoreriaReadingFiltersDtoProps | undefined
    }>
  >,
  handleOpenDocumentoModal: (id: string) => void,
  onRenderActionIcons: (
    rowData: FlujoTesoreriaReadingFiltersDtoProps
  ) => JSX.Element,
  onRenderCoincidenciasMovimientos: (
    rowData: FlujoTesoreriaReadingFiltersDtoProps
  ) => JSX.Element
) => {
  const columns = [
    {
      key: "identificador",
      header: `${t("pagoCobro.tab.headerId")}`,
      field: "identificador",
      className: "tw-text-text !tw-pl-6",
      sortable: true,
      sortField: "identificador",
      style: { width: "5%" },
    },
    {
      key: "fecha",
      header: `${t("pagoCobro.tab.headerDate")}`,
      field: "fecha",
      className: "tw-text-text",
      body: ({ fecha }: FlujoTesoreriaReadingFiltersDtoProps) =>
        fecha ? frontendDateFormat(new Date(fecha)) : "-",
      sortable: true,
      sortField: "fecha",
      style: { width: "5%" },
    },
    {
      key: "razonSocial",
      header: `${t("pagoCobro.tab.headerCompanyName")}`,
      field: "razonSocial",
      className: "tw-text-text",
      sortable: true,
      sortField: "empresa.razonsocial",
      style: { width: "20%" },
    },
    {
      key: "cuenta",
      header: `${t("pagoCobro.tab.headerAccount")}`,
      field: "cuentaBancaria",
      className: "tw-text-text",
      body: ({ cuentaBancaria }: FlujoTesoreriaReadingFiltersDtoProps) =>
        cuentaBancaria ? OnRenderAccountInfo(cuentaBancaria) : "-",
      sortable: false,
      style: { width: "25%" },
    },
    {
      key: "descripcion",
      field: "descripcion",
      header: `${t("pagoCobro.tab.headerDescription")}`,
      className: "tw-text-text",
      sortable: true,
      sortField: "descripcion",
      style: { width: "20%" },
    },
    {
      key: "conciliacionBancariaId",
      field: "conciliacionBancariaId",
      header: `${t("pagoCobro.tab.headerReconcile")}`,
      className: "tw-text-text !tw-text-nowrap",
      sortable: true,
      sortField: "conciliacionBancariaId",
      body: (rowData: FlujoTesoreriaReadingFiltersDtoProps) =>
        rowData.conciliacion?.tipoConciliacion === TIPO_CONCILIACION.FORZADA
          ? onRenderCoincidenciasMovimientos(rowData)
          : ConciliableLabel(t, rowData, setShowModalConciliacion),
    },
    {
      key: "documento",
      field: "documento",
      header: `${t("pagoCobro.tab.headerDoc")}`,
      className: "tw-text-text !tw-text-nowrap",
      body: (rowData: FlujoTesoreriaReadingFiltersDtoProps) =>
        DocumentoAsociadoAsiento(rowData, handleOpenDocumentoModal),
      sortable: true,
      sortField: "factura.serie",
      style: { width: "6%" },
    },
    {
      key: "total",
      header: `${t("pagoCobro.tab.headerTotal")}`,
      field: "importe",
      className: "tw-text-text !tw-text-right !tw-font-medium",
      alignCol: "right",
      body: (rowData: FlujoTesoreriaReadingFiltersDtoProps) =>
        rowData.importe ? ConciliacionesImporteTemplate(rowData) : null,
      sortable: true,
      sortField: "importe",
    },
    {
      key: "action",
      header: " ",
      field: "",
      className: "tw-text-text !tw-p-2",
      body: (rowData: FlujoTesoreriaReadingFiltersDtoProps) =>
        onRenderActionIcons(rowData),
      sortable: false,
      style: { width: "2%" },
    },
  ]
  return columns
}
